import _ from 'lodash'
import { REQUEST } from 'crom-api-constants'

// eslint-disable-next-line max-len
export const LOCALE_PREFIX =
    'scenes.Gnosus.scenes.Report.components.Workspace.components.Blocks.Estates.components.OwnershipTab.components.OwnershipListDetail.components.EstateDetail'

export const LOAD_REALESTATES_ESTATES_OWNERSHIP_ESTATE_DETAIL_DATA_TABLE =
    'LOAD_REALESTATES_ESTATES_OWNERSHIP_ESTATE_DETAIL_DATA_TABLE'
export const DATA_REQUEST = (module, id, blockKey, listId, objectId) =>
    // eslint-disable-next-line max-len
    `DATA_${_.toUpper(module)}_${_.toUpper(id)}_${_.toUpper(blockKey)}_OWNERSHIP_ESTATE_DETAIL_${_.toUpper(
        listId
    )}_${_.toUpper(objectId)}_${REQUEST}`
export const REMOVE_REALESTATES_ESTATES_OWNERSHIP_ESTATE_DETAIL_DATA_TABLE =
    'REMOVE_REALESTATES_ESTATES_OWNERSHIP_ESTATE_DETAIL_DATA_TABLE'

export const ENDED_PROCEEDING_CODE = '4B'
